export default __webpack_public_path__ + "static/media/Vector.91e988b6.svg";